import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import {
  POST_QUALITY_INDICATOR_COLORS,
  POST_QUALITY_INDICATOR_ICONS,
  PostQualityIndicatorType
} from "@shared/interfaces/user-post-quality.interface";

@Component({
  selector: "astrobin-post-quality-indicator-pill",
  templateUrl: "./post-quality-indicator-pill.component.html",
  styleUrls: ["./post-quality-indicator-pill.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PostQualityIndicatorPillComponent {
  @Input() indicator: PostQualityIndicatorType;
  @Input() size: "small" | "medium" | "large" = "medium";

  constructor(private readonly translateService: TranslateService) {}

  get label(): string {
    return this.humanizePostQualityIndicator(this.indicator);
  }

  humanizePostQualityIndicator(indicator: PostQualityIndicatorType): string {
    switch (indicator) {
      case PostQualityIndicatorType.WELL_WRITTEN:
        return this.translateService.instant("Well written");
      case PostQualityIndicatorType.HELPFUL_EXPLANATION:
        return this.translateService.instant("Helpful");
      case PostQualityIndicatorType.INSIGHTFUL:
        return this.translateService.instant("Insightful");
      case PostQualityIndicatorType.RESPECTFUL_TONE:
        return this.translateService.instant("Respectful");
      case PostQualityIndicatorType.CONCISE:
        return this.translateService.instant("Concise");
      case PostQualityIndicatorType.ENGAGING:
        return this.translateService.instant("Engaging");
      case PostQualityIndicatorType.SUPPORTIVE:
        return this.translateService.instant("Supportive");
      default:
        return "";
    }
  }

  get color(): string {
    return POST_QUALITY_INDICATOR_COLORS[this.indicator];
  }

  get icon(): string {
    return POST_QUALITY_INDICATOR_ICONS[this.indicator];
  }

  get tooltipText(): string {
    switch (this.indicator) {
      case PostQualityIndicatorType.WELL_WRITTEN:
        return this.translateService.instant("Posts are clearly structured and easy to understand");
      case PostQualityIndicatorType.HELPFUL_EXPLANATION:
        return this.translateService.instant("Provides valuable explanations and guidance");
      case PostQualityIndicatorType.INSIGHTFUL:
        return this.translateService.instant("Offers unique perspectives and deep understanding");
      case PostQualityIndicatorType.RESPECTFUL_TONE:
        return this.translateService.instant("Maintains courteous and professional communication");
      case PostQualityIndicatorType.CONCISE:
        return this.translateService.instant("Communicates efficiently without unnecessary details");
      case PostQualityIndicatorType.ENGAGING:
        return this.translateService.instant("Creates interesting discussions and interactions");
      case PostQualityIndicatorType.SUPPORTIVE:
        return this.translateService.instant("Encourages and helps community members");
      default:
        return "";
    }
  }
}
